const ReturnPolicy = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-12">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className="text-bold headingsize">
									Returns & <span className="primecolor">Replacement</span>
								</h4>

								<ul className="mt-32">
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900">
											Our full effort is to provide customers with exactly what
											they need. Any issue regarding returns, replacements, or
											refunds can be reported via WhatsApp, email, or through
											our contact section on the Dashboard.
										</span>
									</li>
								</ul>

								<h6 className="mt-24">
									Return <span className="primecolor">Policy</span>
								</h6>
								<ul className="mt-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Product is in the same condition as delivered.
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Packaging is intact and unopened.
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Return requested within 3 working days of delivery.
										</span>
									</li>
								</ul>

								<h6 className="mt-24">
									Replacement Due to{" "}
									<span className="primecolor">Manufacturing Defects</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Notify us via email or WhatsApp within 5 working days. We
										will forward the case to the manufacturer and update you
										within 3 to 5 working days.
									</li>
								</ul>

								<h6 className="mt-24">
									Return / Replacement{" "}
									<span className="primecolor">Scenarios</span>
								</h6>
								<ul className="mt-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Wrong product sent
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Product is defective
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Damaged during shipping
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Tampered product
										</span>
									</li>
								</ul>

								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Report with complaint and photos via WhatsApp or email
										within 12 working hours of receiving item. Action will be
										taken on priority, and the resolution will be shared within
										36 working hours.
									</li>
								</ul>

								<h6 className="mt-24">
									Replacement & Refund{" "}
									<span className="primecolor">Process</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										If approved, the product will be replaced at no cost within
										normal delivery timeframe. If out of stock, reimbursement
										will follow:
									</li>
									<li className="text-md text-gray-900 mb-14">
										<strong>3 to 5 Working Days:</strong> Cash, Swipe on
										delivery, or Net Banking.
									</li>
									<li className="text-md text-gray-900 mb-14">
										<strong>10 to 15 Working Days:</strong> Online payments
										(Card or Net Banking).
									</li>
									<li className="text-md text-gray-900 mb-14">
										Refunds will only be made to the original payment method.
										Products must be returned with original packaging and
										accessories.
									</li>
								</ul>

								<h6 className="mt-24">
									Shipping <span className="primecolor">Charges</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Shipping costs are non-refundable. They will be deducted
										from the total order refund. Customers must return the
										product to our drop-off points in the UAE or opt for paid
										pickup (50% of original delivery cost will be deducted).
									</li>
								</ul>

								<h6 className="mt-24">
									Wallet <span className="primecolor">Policy</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Wallet balance can be used for any purchase on the site.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Discounts/loyalty rewards added only after return period
										ends.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Approved refunds will be added to wallet if opted.
									</li>
								</ul>

								<h6 className="mt-24">
									Cancellation <span className="primecolor">Policy</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Orders can be canceled within 24 hours. Refund will be
										processed to original payment method.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Allow up to 15 days for refund to reflect.
									</li>
									<li className="text-md text-gray-900 mb-14">
										No cash refunds; refunds go to wallet only.
									</li>
									<li className="text-md text-gray-900 mb-14">
										To add funds to wallet, send payment via Net Banking and
										share slip with registered number on WhatsApp. Wallet will
										be updated within 12 working hours.
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default ReturnPolicy;
